import * as React from "react"
import { Input as InputPrimitive } from "@base-ui/react/input"

import { cn } from "@/lib/utils"

function Input({
  className,
  type,
  // Dropped for EVERY input, deliberately. Conform derives `pattern` from the
  // Zod constraint, and for `.email()` the client emits one while the server
  // does not — a hydration mismatch logged on every load of /login, /signup
  // and /auth/reset. Costs nothing: Conform renders these forms `noValidate`
  // because it owns validation, so `pattern` never fires; it is inert markup.
  //
  // Handled HERE rather than per call site because it is a property of the
  // constraint pipeline, not of any one field: 13 getInputProps call sites
  // funnel through this component, and an earlier per-call-site helper
  // guarded only 3 of them — leaving the other 10 one `.regex()` away from
  // the same warning, and re-running a spread+delete on every keystroke
  // (Conform revalidates onInput after a failed submit).
  //
  // Verified there is no intentional `pattern=` anywhere in app/ or
  // components/, so nothing legitimate is lost.
  ...props
}: React.ComponentProps<"input">) {
  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      className={cn(
        "h-8 w-full min-w-0 rounded-lg border border-input bg-transparent px-2.5 py-1 text-base transition-colors outline-none file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 md:text-sm dark:bg-input/30 dark:disabled:bg-input/80 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40",
        className
      )}
      {...props}
      // AFTER the spread, deliberately — before it, `{...props}` would put the
      // Conform-derived pattern straight back. See the note above.
      pattern={undefined}
    />
  )
}

export { Input }
